// extracted by mini-css-extract-plugin
export var modal = "_4i-0";